import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  AfterViewInit
} from '@angular/core';
import { EventMessageComponent } from '../../shared/components/handler-server-respond/handler-server-respond.component';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Address, fareStatus, iTarfif, Order } from '../order.interface';
import {
  MAT_DIALOG_DATA,
  MatAutocompleteSelectedEvent,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MatInput,
  MatSelect,
  MatSnackBar,
  MatSnackBarConfig,
  MatAutocompleteTrigger
} from '@angular/material';
import 'rxjs/add/operator/skip';
import { Subject } from 'rxjs/Subject';
import { WsService } from '../../shared/services/ws.service';
import { debounceTime, distinctUntilChanged, filter, skipWhile, switchMap, takeUntil, mergeMap } from 'rxjs/operators';
import { ModalCloseComponent, ProductsService } from '../../shared/index';
import { OrderFormChangeTarifComponent } from '../order-form-change-tarif/order-form-change-tarif.component';
import { OrderFormRecountConfirmComponent } from '../order-form-recount-confirm/order-form-recount-confirm.component';
import { AddressService } from '../services/address.service';
import { PassangerService } from '../services/passanger.service';
import { OrderService } from '../../shared/services/order.service';
import { featuresBind } from '../../config/features';
import { FeatureService } from '@app/shared/services/feature.service';
import { SettingsService } from '@app/shared/services/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { CardPaymentComponent } from '../card-payment/card-payment.component';
import { NotificationService } from '@app/shared/services/notification.service';
import { LockService } from '../services/lock.service';
import { of } from 'rxjs/observable/of';
import { PaymentService } from '../services/payment.service';
import { KsInfoModalComponent } from '../ks-info-modal/ks-info-modal.component';

@Component({
  selector: 'app-order-form',
  templateUrl: './order-form.component.html',
  styleUrls: ['./order-form.component.scss']
})
export class OrderFormComponent implements OnInit, OnDestroy, AfterViewInit {
  info = null;
  currentOrder: Order = null;
  @ViewChild('time') time: ElementRef;
  @ViewChild('tarifRef', { read: MatInput }) tarifRef: MatInput;
  @ViewChild('passangerName', { read: MatInput }) passangerName: MatInput;
  @ViewChild('clientPhone', { read: MatInput }) clientPhone: MatInput;
  @ViewChild('preOrderTime', { read: MatInput }) preOrderTime: MatInput;
  @ViewChild('orderFeatures', { read: MatSelect }) orderFeatures: MatSelect;
  @ViewChild(MatAutocompleteTrigger) choiseTarif: MatAutocompleteTrigger;
  @ViewChildren('formRow') addressList: QueryList<ElementRef>;
  @ViewChildren('queryAddres', { read: MatInput }) addressLists: QueryList<MatInput>;
  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger;
  @ViewChildren(MatAutocompleteTrigger) triggers: QueryList<MatAutocompleteTrigger>;

  triggersArr = [];

  confirmRef: MatDialogRef<OrderFormRecountConfirmComponent>;
  changeTarifRef: MatDialogRef<OrderFormChangeTarifComponent>;

  lock_buttons: boolean = null; // TODO lock button wrapper
  orderForm: FormGroup;
  search$ = new Subject<string>();
  data_id = '';
  order_id = '';
  tarif_id = '';
  selectedLanguage = 'ru';
  languages = ['ru', 'ua', 'en'];
  ksModalOpened = false;
  order_added_summ: {
    msg;
    id;
  } = null;
  fare: any = null;
  old_fare: any = null;
  fareStatus: fareStatus = {
    show: false,
    proccesing: false,
    status: false,
    changed: false
  };
  tarif: any = {};
  products: iTarfif[] = [];
  filteredProducts: iTarfif[] = [];
  taxiServices: any;

  entrance = null; // парадное;
  disable_entrance = false;
  selectedOrderType = false;
  preorderedTime: Date = new Date();
  CurrentTime = this.pad(new Date().getHours()) + ':' + this.pad(new Date().getMinutes());
  focuseedAddressPosition: number = null; // TODO for track current focus address -> remove/addAfterAddress
  Addresses: FormArray;
  checkedAddresses = []; // array of real address;
  filtredAddress = []; // list of founded place
  minDate = new Date();
  ready = false; // window state
  opened = false;
  saveProccess = false;
  editTimeEnd = false;
  private componentDestroyed = new Subject<any>();
  fareDataCopy: any;
  passengerCountOrders = -1;
  passengerIsBlocked = false;
  commentAboutPassenger = '';
  bonus_balance;
  visitedAddresses = [];
  isPreorderTimeValue = false;
  bonusAmount = 0;
  driverAmount = 0;
  downClick = false;
  translate: any;
  // edit timing
  timerString: string;
  timerEnding = false;
  private timeToLockInMilisec = 0;

  showOptionsTrigger;
  currentService;
  mapPoints = [];
  addressType = 'all';
  query = '';
  phonePaymentId;
  useKsPayment = false;

  hideMap = false;

  editModeEnabled = false;

  subscriptionObj = {
    next: () => {
      this.handleServiceEvent(this.currentOrder ? 'Order updated' : 'Order created');
      if (
        !(
          this.currentOrder &&
          this.currentOrder.trip &&
          this.currentOrder.payment_type == 'card' &&
          this.fare.amount > this.currentOrder.fare.amount
        ) ||
        this.currentOrder.fare.amount == this.fare.amount
      ) {
        this.dialogRef.close();
      }
    },
    error: err => {
      this.saveProccess = false;
    }
  };

  constructor(
    private fb: FormBuilder,
    private product: ProductsService,
    private addressService: AddressService,
    private passService: PassangerService,
    private orderService: OrderService,
    private notification: NotificationService,
    private ws: WsService,
    public cd: ChangeDetectorRef,
    private dialog: MatDialog,
    translate: TranslateService,
    private lockService: LockService,
    private snackBar: MatSnackBar,
    private viewContainerRef: ViewContainerRef,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<OrderFormComponent>,
    private featureService: FeatureService,
    private paymentService: PaymentService,
    public settingsService: SettingsService
  ) {
    this.taxiServices = data.taxiServices;
    this.hideMap = data.hideMap;
    let rawTarif = this.sortProducts(data.products);
    this.translate = translate;
    this.currentOrder = data.order;
    this.info = data.orderInfo;
    for (let i = 0; i < this.taxiServices.length; i++) {
      const id = this.taxiServices[i].id + '';
      this.tarif[id] = [];
    }
    for (let i = 0; i < rawTarif.length; i++) {
      let obj = rawTarif[i];
      this.tarif[obj.service_id].push(rawTarif[i]);
    }
  }

  disableStaticControls() {
    this.orderForm.controls['service'].disable();
    this.orderForm.controls['passenger'].get('phone').disable();
    this.orderForm.controls['orderType'].disable();
  }

  init() {
    this.selectedOrderType = this.currentOrder.is_preorder;
    this.checkedAddresses = this.orderForm.get('addresses').value.filter(val => {
      return !(!val.address_id && !val.lat && !val.lng && !val.id);
    });
  }

  enableEditMode() {
    this.lockService.lock({ id: this.currentOrder.id, mode: 'normal' }).subscribe(() => {
      this.editModeEnabled = true;
    });
  }

  ngOnInit() {
    if (this.currentOrder) {
      this.orderForm = this.toFormGroup(this.currentOrder);
      this.init();
      this.orderService.getFare({ id: this.currentOrder.fare.id }).subscribe(res => {
        this.fare = res['data'];
        this.driverAmount =
          this.fare.amount - this.currentOrder.paid_amount - (this.bonus_balance < 1 ? 0 : this.bonus_balance);
        if (this.driverAmount) {
          this.bonusAmount = this.fare.amount - this.driverAmount;
        }
      });

      if (this.lockService.mode === 'default') {
        this.orderForm.disable();
        this.lockService.mode$.subscribe(mode => {
          console.log('PC: ngOnInit -> mode', mode);
          if (mode == 'normal') {
            this.orderForm.enable();
            this.orderForm.setControl('addresses', this.fb.array(this.buildAddresses(this.currentOrder.waypoints)));
            this.Addresses = this.orderForm.get('addresses') as FormArray;
            this.disableStaticControls();
            this.init();

            this.setEditTimer();
          }
        });
      }
      this.useKsPayment = this.currentOrder.payment_type == 'phone';
      //  this.countPrice()
    } else {
      this.orderForm = this.toFormGroup();
      this.disable_entrance = true;
      this.lock_buttons = true;
      this.orderForm.disable();
      this.orderForm
        .get('passenger')
        .get('phone')
        .enable();
      this.orderForm.get('service').enable();
      this.orderForm.get('tarif').enable();
      if (this.orderForm.get('passenger').get('phone').value.length > 0) {
        this.setUser();
      }
    }

    // this.filteredProducts = this.products = this.sortProducts(this.tarif[this.orderForm.get('service').value.toString()]);

    this.addressService.city = this.taxiServices
      .filter(item => {
        if (this.orderForm.get('service').value == item.id) {
          return true;
        }
      })
      .map(item => item.city)[0];
    this.orderForm
      .get('service')
      .valueChanges.pipe(
        skipWhile(() => {
          if (this.info !== null && this.info !== undefined) {
            this.info = null;
            return true;
          }
        }),
        distinctUntilChanged(),
        takeUntil(this.componentDestroyed)
      )
      .subscribe({
        next: data => {
          // this.filteredProducts = this.products = this.sortProducts(this.tarif[data.toString()]);
          this.currentService = data;
          this.product.getFilteredProducts(this.orderForm.get('service').value).subscribe({
            next: result => {
              this.filteredProducts = this.products = this.sortProducts(result.data);
              // if (!this.orderForm.get('tarif').value)
              this.setDefaultTariff();
            },
            error: err => {
              console.log(err);
            }
          });
          if (!this.orderForm.get('tarif').value) {
            this.orderForm.get('tarif').patchValue({
              name: this.products[0].name,
              id: this.products[0].id
            });
          }
          this.addressService.city = this.taxiServices
            .filter(item => {
              if (this.orderForm.get('service').value == item.id) {
                return true;
              }
            })
            .map(item => item.city)[0];
          this.Addresses.reset([this.buildDestAddress(), this.buildDestAddress()]);
          this.featureService.getFeatures(this.orderForm.get('service').value).subscribe(obj => {
            if (this.currentOrder) {
              this.featuresActive(obj, this.currentOrder.features);
            } else {
              this.featuresActive(obj);
            }
          });
          this.cd.detectChanges();
        },
        error: err => {
          console.log('getservice', err);
          this.dialogRef.close();
        }
      });

    this.orderForm.get('tarif').valueChanges.subscribe(res => {
      if (typeof res.name == 'object') {
        this.orderForm.get('tarif').patchValue({
          name: res.name.name,
          id: res.id
        });
        return;
      }
      this.filteredProducts = this.products.filter(product =>
        product.name.toLowerCase().includes(res.name.toLowerCase())
      );
    });
    this.ws.message.pipe(takeUntil(this.componentDestroyed)).subscribe(data => {
      let res = JSON.parse(data);
      if (res.header.data_id == this.order_id) {
        if (res.header.status.toLowerCase() == 'ok') {
        }
        if (res.header.status.toLowerCase() == 'not') {
          this.fare = res.data;
          this.fareStatus.proccesing = false;
          this.fareStatus.show = true;
        }
        this.cd.detectChanges();
      } else if (res.header.data_id == this.tarif_id) {
        if (res.header.status.toLowerCase() == 'ok') {
          this.old_fare = this.fare = res.data;
          this.cd.detectChanges();
        }
      }
    });

    this.Addresses = this.orderForm.get('addresses') as FormArray;

    this.featureService.getFeatures(this.orderForm.get('service').value).subscribe(obj => {
      if (this.currentOrder) {
        this.featuresActive(obj, this.currentOrder.features);
      } else {
        this.featuresActive(obj);
      }
      this.ready = true;
      this.cd.markForCheck();
    });

    this.timer();

    this.search$
      .pipe(
        distinctUntilChanged(),
        debounceTime(this.downClick ? 0 : 300),
        filter(data => data.length == 0 || data.length > 1),
        takeUntil(this.componentDestroyed)
      )
      .subscribe(this.processAddressQuery);

    this.addressService.getAddres.pipe(takeUntil(this.componentDestroyed)).subscribe(data => {
      this.filtredAddress = data;
      this.downClick = false;
      this.cd.markForCheck();
    });

    // this.settingsService.products.pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
    //   // console.log('ressettingsService', res);
    //   if (this.orderForm.get('service').value != undefined) {
    //     this.filteredProducts = this.products = this.data.products.filter(
    //       prod => prod.service_id === +this.orderForm.get('service').value
    //     );
    //     // this.filteredProducts = this.products = res[this.orderForm.get('service').value];
    //   }
    //   this.cd.detectChanges();
    // });
    this.filteredProducts = this.products = this.data.products.filter(
      prod => prod.service_id === +this.orderForm.get('service').value
    );
  }

  ngAfterViewInit() {
    this.trigger.panelClosingActions.subscribe(event => {
      if (!event['name']) {
        this.setDefaultTariff();
      }
      this.addressType = 'all';
    });

    this.triggersArr = this.triggers.toArray();
    if (this.currentOrder) {
      this.mapPoints = this.checkedAddresses;
    }
  }

  processAddressQuery = query => {
    const intercityStr = 'МГ';
    let isIntercity = false;
    this.query = query;
    let queryArr = query.split(' ').filter(el => el);
    if (queryArr.length && queryArr[0].toUpperCase() == intercityStr) {
      isIntercity = true;
      queryArr[0] = '';
    }
    query = queryArr.join(' ');
    this.addressService.setAddresses(
      query,
      this.selectedLanguage,
      isIntercity,
      this.orderForm.getRawValue().passenger.id,
      this.addressType
    );
  };

  addressTypeChecked(trigger?) {
    this.processAddressQuery(this.query);
  }

  private sortProducts(data): any[] {
    return data.sort((a, b) => {
      if (a.is_default < b.is_default) {
        return 1;
      }
      if (a.is_default > b.is_default) {
        return -1;
      }
      return 0;
    });
  }

  ngOnDestroy() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
    this.componentDestroyed.next();
    this.componentDestroyed.unsubscribe();
  }

  FareStatus() {
    this.fareStatus.status = false;
    if (!this.currentOrder) {
      if (this.checkedAddresses.length > 1 || this.orderForm.controls.incity.value) {
        this.countPrice();
      }
    }
  }

  featuresActive(data, orderFeat?): void {
    let imgsFeature = featuresBind;

    let activeFeatures = [];
    let features = this.fb.array(
      data
        .map((item, index) => {
          let obj = {
            id: item.id,
            name: item.name,
            state: item.state,
            default: item.default,
            active: false,
            key: item.key,
            img: null
          };
          for (let i = 0; i < imgsFeature.length; i++) {
            let obgI = imgsFeature[i];
            if (item.key == obgI.name) {
              obj.img = obgI.url;
            }
          }
          if (orderFeat) {
            let orderFeature = orderFeat;
            for (let i = 0; i < orderFeature.length; i++) {
              let obj1 = orderFeature[i];
              if (obj1.id === item.id) {
                obj.active = true;
                activeFeatures.push(index);
              }
            }
          }
          return obj;
        })
        .map(feature => {
          return this.fb.group(feature);
        })
    );
    if (!!activeFeatures) {
      this.orderForm.get('activeFeatures').setValue(activeFeatures);
    }
    this.orderForm.setControl('features', features);
  }

  setAddressView(event) {
    if (event !== undefined && event !== null) {
      if (typeof event == 'string') {
        return event;
      }
      if (this.currentOrder) {
        this.fareStatus.status = false;
      }
      this.filtredAddress = [];

      return event.name;
    }
  }

  setAddress(event: MatAutocompleteSelectedEvent, i) {
    let obj = event.option.value;

    this.Addresses.at(i).patchValue({
      name: obj.name,
      lat: obj.lat,
      lng: obj.lng,
      address_id: obj.id,
      id: obj.id,
      intercity: obj.intercity,
      relation_id: obj.relation_id
    });

    this.checkedAddresses = this.Addresses.value.filter(val => {
      return !(!val.address_id && !val.lat && !val.lng && !val.id);
    });

    this.orderForm.get('intercity').setValue(!!this.checkedAddresses.find(el => el.intercity));

    if (this.checkedAddresses.length > 1 && !this.currentOrder) {
      this.countPrice();
    } else {
      this.fareStatus.status = false;
    }

    console.log(this.checkedAddresses);

    this.mapPoints = this.Addresses.value.filter(address => address.name);
  }

  changeTime() {
    if (this.preOrderTime.value.length == 5) {
      this.countPrice();
    }
  }

  setTarif(event) {
    if (typeof event == 'string' || event === null) {
      return event;
    } else {
      this.orderForm.get('tarif').patchValue({
        name: event.name,
        id: event.id
      });
      if (!this.currentOrder) {
        if (this.checkedAddresses.length > 1 || this.orderForm.controls.incity.value) {
          this.countPrice();
        }
      } else {
        this.fareStatus.status = false;
      }
      return event.name;
    }
  }

  serviceChanged(service) {
    console.log('TCL: serviceChanged -> service', service);
    if (this.orderForm.get(['passenger', 'phone']).value) {
      this.setUser();
    }
    this.settingsService.setCurrentServiceId(this.orderForm.get('service').value);
    this.setDefaultTariff();
    this.filtredAddress = [];
    if (this.fare) {
      this.fare.amount = 0;
    }
    this.fareStatus.status = false;

    this.product.getFilteredProducts(this.orderForm.get('service').value).subscribe({
      next: result => {
        this.filteredProducts = this.products = result.data;
      },
      error: err => {
        console.log(err);
      }
    });
  }

  setUser() {
    let phone = this.orderForm.get(['passenger', 'phone']).value;
    this.passService.getPassanger(phone, this.orderForm.get('service').value).subscribe(
      data => {
        console.log(
          this.settingsService.settings[this.orderForm.get('service').value].accounting_enabled_phone_payment
        );

        if (
          phone.match(/^\+?3?8?(0(67|68|96|97|98)\d{7})$/) &&
          this.settingsService.settings[this.orderForm.get('service').value].accounting_enabled_phone_payment == '1'
        ) {
          this.paymentService.getPaymentMethod(data['data'].id, phone, 'phone').subscribe((res: any) => {
            this.phonePaymentId = res.id;
          });
        } else {
          this.phonePaymentId = null;
        }
        this.passService
          .getPassengerById(data['data'].id, this.orderForm.get('service').value)
          .subscribe((res: any) => {
            this.passengerCountOrders = res['completed_requests_count'];
            this.passengerIsBlocked = res['data']['is_blocked'];
            if (this.passengerIsBlocked) {
              this.commentAboutPassenger = `${res.block_reason ? res.block_reason.name : ''}: ${
                res.block_comment ? res.block_comment : ''
              }`;
            }
            this.bonus_balance = res['bonus_balance'];
            this.visitedAddresses = res['addresses'];
          });
        this.orderForm.get('passenger').patchValue({
          id: data['data'].id,
          comment: data['data'].comment,
          name: data['data'].name
        });
        if (this.disable_entrance) {
          this.orderForm.enable();
          if (this.checkedAddresses.length < 1) {
            this.orderForm.get('incity').disable();
          }
          this.disable_entrance = false;
          this.lock_buttons = false;

          setTimeout(() => {
            if (this.addressLists.first) {
              this.addressLists.first.focus();
            }
          }, 4);
        }
      },
      err => {
        console.log('setuser ', err);
      }
    );
  }

  openKsModal() {
    this.ksModalOpened = true;
    this.dialog
      .open(KsInfoModalComponent, { width: '600px' })
      .afterClosed()
      .subscribe(res =>
        setTimeout(() => {
          this.ksModalOpened = false;
        }, 200)
      );
  }

  checkboxesChange(rout: string) {
    switch (rout) {
      case 'intercity':
        if (this.orderForm.controls.intercity.value) {
          this.orderForm.controls.incity.setValue(false);
          this.orderForm.controls.pass_comment.setValue('');
        }
        break;
      case 'incity':
        if (this.orderForm.controls.incity.value) {
          this.orderForm.controls.is_incomplete.setValue(true);
          this.orderForm.controls.intercity.setValue(false);
          this.orderForm.controls.pass_comment.setValue(
            `${this.orderForm.controls.pass_comment.value} ${this.translate.get('INCITY').value}`
          );
        } else {
          this.orderForm.controls.pass_comment.setValue('');
        }
        break;
    }
  }

  preorderChanged(is_preorder) {
    this.selectedOrderType = is_preorder;
    this.countPrice();
  }

  countPrice() {
    // request to server for count summ
    let arr = this.checkedAddresses;
    if (!arr) {
      return;
    }
    let formVal = this.orderForm.getRawValue();
    this.data_id = Date.now().toString();
    let services = formVal.features
      .filter((_item, index) => {
        let obj1 = this.orderForm.get('activeFeatures').value;
        if (obj1.indexOf(index) != '-1') {
          return true;
        }
      })
      .map(item => item.key);

    this.fareStatus.proccesing = true;
    this.fareStatus.status = false;
    this.fareStatus.show = false;

    let data: any = {
      service: formVal.service,
      product_id: formVal.tarif.id,
      waypoints: [],
      passenger_id: formVal.passenger.id,
      is_preorder: this.selectedOrderType,
      is_intercity: formVal.intercity,
      is_by_the_city: formVal.incity
    };

    if (this.selectedOrderType) {
      let h = formVal.preorderedTime.split('.');
      if (h.length == 2) {
        let date = new Date(new Date(formVal.preorderedDate).setHours(h[0], h[1]));
        data['assigned_at'] = date.toISOString();
      } else {
        data.is_preorder = false;
      }
    }

    let obj = {
      header: {
        type: 'req',
        action: 'estimate',
        data_id: this.data_id
      },
      data: data
    };

    if (services.length) {
      obj.data['services'] = services;
    }

    if (this.data.order) {
      obj.data.request_id = this.data.order.id;
    }

    if (arr[0] && arr[0].address_id !== null) {
      obj.data['start_point'] = {
        address_id: arr[0].address_id
      };
    } else if (arr[0].id !== null) {
      obj.data['start_point'] = {
        waypoint_id: arr[0].id
      };
    } else {
      obj.data['start_point'] = {
        name: arr[0].name,
        latitude: arr[0].lat,
        longitude: arr[0].lng
      };
    }

    if (arr[arr.length - 1].address_id !== null) {
      console.log('TCL: countPrice -> arr.length - 1', arr.length - 1);
      obj.data['end_point'] = {
        address_id: arr[arr.length - 1].address_id
      };
    } else if (arr[arr.length - 1].id !== null) {
      obj.data['end_point'] = {
        waypoint_id: arr[arr.length - 1].id
      };
    } else {
      obj.data['end_point'] = {
        name: arr[arr.length - 1].name,
        latitude: arr[arr.length - 1].lat,
        longitude: arr[arr.length - 1].lng
      };
    }

    if (arr.length > 2) {
      for (let i = 1; i < arr.length - 1; i++) {
        if (arr[i].address_id !== null) {
          obj.data.waypoints.push({
            address_id: arr[i].address_id
          });
        } else if (arr[i].id !== null) {
          obj.data.waypoints.push({
            waypoint_id: arr[i].id
          });
        } else {
          obj.data.waypoints.push({
            name: arr[i].name,
            latitude: arr[i].lat,
            longitude: arr[i].lng
          });
        }
      }
    }

    this.fareDataCopy = obj.data;
    const newEstimator = this.settingsService.settings[formVal.service]
      ? this.settingsService.settings[formVal.service]['system_build_in_estimate']
      : 0;
    this.orderService.countWay(obj.data, newEstimator).subscribe({
      next: res => {
        if (this.currentOrder !== null) {
          this.openConfirmPopup(res);
        } else {
          this.fare = res;
        }
        if (res['code'] == undefined) {
          this.fareStatus.status = true;
        }

        if (this.currentOrder) {
          this.driverAmount =
            this.fare.amount - this.currentOrder.paid_amount - (this.bonus_balance < 1 ? 0 : this.bonus_balance);

          if (this.driverAmount) {
            this.bonusAmount = this.fare.amount - this.driverAmount;
          }
        }
        this.fareStatus.proccesing = false;
        this.fareStatus.show = true;
        this.cd.markForCheck();
      },
      error: err => {
        this.fare = JSON.parse(err.error);
        this.fareStatus.proccesing = false;
        this.fareStatus.show = true;
        this.cd.markForCheck();
      }
    });
  }

  openConfirmPopup(newFare) {
    // open popup with summ of fares
    let config = new MatDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    config.data = {
      oldFare: this.fare,
      newFare: newFare
    };
    this.confirmRef = this.dialog.open(OrderFormRecountConfirmComponent, config);
    this.opened = true;
    this.confirmRef.afterClosed().subscribe(result => {
      this.confirmRef = null;
      this.opened = false;
      if (result) {
        this.fare = newFare;
        this.fareStatus.changed = true;
        this.cd.markForCheck();
      }
    });
  }

  openTarifChangePopup() {
    let config = <MatDialogConfig>{
      data: { fare: this.fare },
      hasBackdrop: true,
      width: '350px',
      height: '300px',
      autoFocus: true
    };
    config.viewContainerRef = this.viewContainerRef;

    this.changeTarifRef = this.dialog.open(OrderFormChangeTarifComponent, config);
    this.opened = true;
    this.changeTarifRef.afterClosed().subscribe(result => {
      this.changeTarifRef = null;
      this.opened = false;

      if (result) {
        this.order_added_summ = {
          msg: result,
          id: result.header.data_id
        };

        this.fare.added_value = result.data.added_value;
        this.fare.amount = +this.fare.value + +result.data.added_value;
        if (this.currentOrder) {
          this.driverAmount = this.fare.amount - this.currentOrder.paid_amount - this.bonus_balance;
          if (this.driverAmount) {
            this.bonusAmount = this.fare.amount - this.driverAmount;
          }
        }
        this.cd.detectChanges();
      }
    });
  }

  prepareSaveOrder(duplicateFareId?) {
    let formVal = this.orderForm.getRawValue();

    this.order_id = Date.now().toString();

    if (formVal.addresses) {
      formVal.addresses = formVal.addresses.filter(item => {
        return !(!item.address_id && !item.lat && !item.lng && !item.id);
      });
    }

    let changedPhone = formVal.passenger.phone_number;

    let services = formVal.features.filter(item => item.active).map(item => item.key);

    let obj;

    if (this.currentOrder) {
      obj = {
        header: {
          type: 'req',
          action: 'put',
          data_id: this.order_id
        },
        data: {
          id: this.currentOrder.id,
          waypoints: [],
          passenger_id: formVal.passenger.id,
          service: formVal.service,
          payment_type: formVal.payment_type
        }
      };
      if (this.fareStatus.changed) {
        obj.data['fare_id'] = this.fare.id;
      }
      if (this.currentOrder.product_id != formVal.tarif.id) {
        obj.data.product_id = formVal.tarif.id;
      }
    } else {
      obj = {
        header: {
          type: 'req',
          action: 'store',
          data_id: this.order_id
        },
        data: {
          is_preorder: formVal.orderType,
          service: formVal.service,
          product_id: formVal.tarif.id,
          fare_id: duplicateFareId ? duplicateFareId : this.fare.id,
          waypoints: [],
          passenger_id: formVal.passenger.id,
          payment_type: formVal.bonus && this.bonus_balance > this.fare.amount ? 'bonus' : 'cash'
        }
      };
    }

    console.log(this.useKsPayment);
    if (this.useKsPayment) {
      obj.data.payment_type = 'phone';
      obj.data.payment_method_id = this.phonePaymentId;
    }

    if (formVal.orderType) {
      let h = formVal.preorderedTime.split('.');
      let date = new Date(new Date(formVal.preorderedDate).setHours(h[0], h[1]));
      obj.data['assigned_at'] = date.toISOString();
    }

    if (changedPhone.length) {
      obj.data.phone_number = changedPhone;
    }

    if (services.length) {
      obj.data['services'] = services;
    }

    console.log(formVal);

    if (formVal.addresses[0].name) {
      obj.data['start_point'] = {
        name: formVal.addresses[0].name.name ? formVal.addresses[0].name.name : formVal.addresses[0].name,
        latitude: formVal.addresses[0].lat,
        longitude: formVal.addresses[0].lng,
        relation_id: formVal.addresses[0].relation_id
      };
    } else if (formVal.addresses[0].address_id !== null) {
      obj.data['start_point'] = {
        address_id: formVal.addresses[0].address_id
      };
    } else {
      obj.data['start_point'] = {
        waypoint_id: formVal.addresses[0].id
      };
    }

    if (formVal.addresses[formVal.addresses.length - 1].name) {
      obj.data['end_point'] = {
        name: formVal.addresses[formVal.addresses.length - 1].name.name
          ? formVal.addresses[formVal.addresses.length - 1].name.name
          : formVal.addresses[formVal.addresses.length - 1].name,
        latitude: formVal.addresses[formVal.addresses.length - 1].lat,
        longitude: formVal.addresses[formVal.addresses.length - 1].lng,
        relation_id: formVal.addresses[formVal.addresses.length - 1].relation_id
      };
    } else if (formVal.addresses[formVal.addresses.length - 1].id !== null) {
      obj.data['end_point'] = {
        waypoint_id: formVal.addresses[formVal.addresses.length - 1].id
      };
    } else {
      obj.data['end_point'] = {
        address_id: formVal.addresses[formVal.addresses.length - 1].address_id
      };
    }

    if (formVal.addresses.length > 2) {
      for (let i = 1; i < formVal.addresses.length - 1; i++) {
        if (formVal.addresses[i].name) {
          obj.data.waypoints.push({
            name: formVal.addresses[i].name.name ? formVal.addresses[i].name.name : formVal.addresses[i].name,
            latitude: formVal.addresses[i].lat,
            longitude: formVal.addresses[i].lng,
            relation_id: formVal.addresses[i].relation_id
          });
        } else if (formVal.addresses[i].id !== null) {
          obj.data.waypoints.push({
            waypoint_id: formVal.addresses[i].id
          });
        } else {
          obj.data.waypoints.push({
            address_id: formVal.addresses[i].address_id
          });
        }
      }
    }

    obj.data['comment'] = formVal.disp_comment;
    obj.data['pass_comment'] = formVal.pass_comment;
    obj.data['is_incomplete'] = formVal.is_incomplete;

    if (!!this.entrance) {
      obj.data['start_comment'] = this.entrance.toString();
    }

    this.fareStatus.proccesing = true;
    this.fareStatus.show = false;

    return obj;
  }

  openCardPayFrom() {
    this.dialog
      .open(CardPaymentComponent, {
        minWidth: 400,
        minHeight: 300,
        data: {
          order: this.currentOrder,
          amount: this.fare.amount
        },
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {
        this.dialogRef.close();
      });
  }

  duplicate() {
    let estimateSetting = this.settingsService.settings[this.orderForm.value.service]['system_build_in_estimate'];
    this.saveOrder().subscribe({
      next: () => {
        this.handleServiceEvent(this.currentOrder ? 'Order updated' : 'Order created');
        this.orderService.countWay(this.fareDataCopy, estimateSetting).subscribe((res: any) => {
          this.saveOrder(res.id).subscribe(this.subscriptionObj);
        });
      },
      error: err => {
        this.orderService.countWay(this.fareDataCopy, estimateSetting).subscribe((res: any) => {
          this.saveOrder(res.id).subscribe(this.subscriptionObj);
        });
      }
    });
  }

  saveSingleOrder() {
    if (this.fare) {
      let isCard = this.currentOrder && this.currentOrder.trip && this.currentOrder.payment_type == 'card';

      if (isCard && this.fare.amount > this.currentOrder.fare.amount) {
        this.openCardPayFrom();
      }
      this.saveOrder().subscribe(this.subscriptionObj);
    }
  }

  saveOrder(fareId?) {
    this.saveProccess = true;
    if (this.order_added_summ !== null) {
      const updateFareArgs = this.order_added_summ.msg.data;
      updateFareArgs.notify = false;
      if (fareId) {
        updateFareArgs.id = fareId;
      }
      return this.orderService.updateFare(updateFareArgs).flatMap((res: any) => {
        return this.saveOrderProcess(this.orderForm.getRawValue(), this.prepareSaveOrder(fareId));
      });
    } else {
      return this.saveOrderProcess(this.orderForm.getRawValue(), this.prepareSaveOrder(fareId));
    }
  }

  saveOrderProcess(formVal, order) {
    return this.passService
      .setPassanger(
        {
          id: formVal.passenger.id,
          comment: formVal.passenger.comment ? formVal.passenger.comment : '',
          name: formVal.passenger.name == null ? '' : formVal.passenger.name,
          phone_number: formVal.passenger.phone,
          country: 'ua'
        },
        formVal.service
      )
      .pipe(
        switchMap(() => {
          return this.currentOrder
            ? this.orderService.updateOrder(order.data)
            : this.orderService.saveOrder(order.data);
        })
      );
  }

  switchMethod(method) {
    if (method == 'bonus') {
      this.useKsPayment = false;
      this.orderForm.get('payment_type').patchValue(this.orderForm.get('bonus').value ? 'cash' : 'bonus');
    } else {
      this.orderForm.get('bonus').patchValue(false);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    if (this.currentOrder.id && this.lockService.mode !== 'default') {
      this.lockService.unlock(this.currentOrder.id).subscribe(() => {
        this.dialogRef.close();
      });
      $event.returnValue = 'Are you sure?';
    }
  }

  @HostListener('window:keydown', ['$event'])
  hotkeyDown($event) {
    if (
      $event.keyCode === 18 ||
      $event.keyCode === 33 ||
      $event.keyCode === 34 ||
      $event.keyCode === 107 ||
      $event.keyCode === 109 ||
      $event.keyCode === 112 ||
      $event.keyCode === 113 ||
      $event.keyCode === 114 ||
      $event.keyCode === 115 ||
      $event.keyCode === 116 ||
      $event.keyCode === 117 ||
      $event.keyCode === 118 ||
      $event.keyCode === 120 ||
      $event.keyCode === 121 ||
      $event.keyCode === 122 ||
      $event.keyCode === 123
    ) {
      $event.preventDefault();
    }
  }

  @HostListener('window:keyup', ['$event'])
  hotkeyHandler($event) {
    if (!this.opened) {
      switch ($event.keyCode) {
        case 18: {
          const types = ['all', 'street', 'place'];
          this.addressType = types[(types.findIndex(el => el == this.addressType) + 1) % 3];
          this.addressTypeChecked();
          break;
        }
        case 27: {
          // escape
          if (!this.ksModalOpened) {
            if (this.checkedAddresses.length && this.lockService.mode !== 'default') {
              let dialogRef = this.dialog.open(ModalCloseComponent, <MatDialogConfig>{
                data: { headerTemplate: 'QUESTION_CLOSE' }
              });
              this.opened = true;
              dialogRef.afterClosed().subscribe(data => {
                this.opened = false;
                if (data == 'true') {
                  this.dialogRef.close();
                }
              });
            } else {
              this.dialogRef.close();
            }
          }

          break;
        }
        case 33: {
          /*if ( !!this.focuseedAddressPosition ) {
                     this.moveAddressUp( this.focuseedAddressPosition );
                     }*/
          break;
        }
        case 40: {
          this.downClick = true;
          break;
        }
        case 107: {
          if (this.focuseedAddressPosition !== null) {
            this.addDestAddressAfter();
          }
          break;
        }
        /* case 109: {
                     if (this.focuseedAddressPosition !== null) {
                         this.removeCurrentAddress();
                     }
                     break;
                 }*/
        case 112: {
          // console.log( 'call client' );
          break;
        }
        case 113: {
          this.clientPhone.focus();
          break;
        }
        case 114: {
          this.passangerName.focus();
          break;
        }
        case 115: {
          this.tarifRef.focus();
          break;
        }
        case 116: {
          if (this.currentOrder && this.lockService.mode != 'default') {
            this.countPrice();
          }
          break;
        }
        case 117: {
          if (this.lockService.mode != 'default') {
            this.openTarifChangePopup();
          }
          break;
        }
        case 118: {
          this.orderFeatures.focus();
          break;
        }
        case 120: { // f9
          if (!this.saveProccess) {
            this.saveSingleOrder();
          }
          break;
        }
        case 121: {
          if (this.phonePaymentId) {
            this.useKsPayment = !this.useKsPayment;
          }
          break;
        }
        case 122: {
          break;
        }
        case 123: {
          if (this.lockService.mode != 'default') {
            if (!this.selectedOrderType) {
              this.selectedOrderType = true;
              setTimeout(() => {
                if (this.preorderedTime) {
                  this.preOrderTime.focus();
                }
              }, 4);
            } else {
              this.selectedOrderType = false;
            }
          }

          break;
        }
      }
    }
  }

  queryAddresses(query) {
    this.search$.next(query);
  }

  moveAddressUp(index) {
    let before = this.Addresses.at(index);
    let after = this.Addresses.at(index - 1);
    this.Addresses.setControl(index - 1, before);
    this.Addresses.setControl(index, after);

    this.checkedAddresses = this.Addresses.value.filter(val => {
      return !(!val.address_id && !val.lat && !val.lng && !val.id);
    });

    if (!this.currentOrder) {
      if (this.checkedAddresses.length > 1 || this.orderForm.controls.incity.value) {
        this.countPrice();
      }
    } else {
      this.fareStatus.status = false;
    }
  }

  moveAddressDown(index) {
    let before = this.Addresses.at(index + 1);
    let after = this.Addresses.at(index);

    this.Addresses.setControl(index, before);
    this.Addresses.setControl(index + 1, after);

    this.checkedAddresses = this.Addresses.value.filter(val => {
      return !(!val.address_id && !val.lat && !val.lng && !val.id);
    });

    if (!this.currentOrder) {
      if (this.checkedAddresses.length > 1 || this.orderForm.controls.incity.value) {
        this.countPrice();
      }
    } else {
      this.fareStatus.status = false;
    }
  }

  buildDestAddress(address?): FormGroup {
    if (address) {
      return this.fb.group({
        name: [address.name],
        id: [address.id],
        lat: [address.lat],
        lng: [address.lng],
        type: [address.type],
        intercity: [address.intercity],
        incity: [address.incity],
        ord: [address.ord],
        address_id: [address.address_id],
        relation_id: [address.relation_id]
      });
    }
    return this.fb.group({
      name: [''],
      lat: [''],
      lng: [''],
      type: [''],
      ord: [''],
      intercity: [false],
      incity: [false],
      address_id: [null],
      id: [null],
      relation_id: [null]
    });
  }

  buildAddresses(Addresses: Address[]) {
    Addresses.sort((a, b) => {
      return a.ord - b.ord;
    });
    let arr = [];
    if (Addresses.length > 0) {
      Addresses.forEach(el => {
        arr.push(this.buildDestAddress(el));
      });
      return arr;
    }
  }

  addDestAddress() {
    this.Addresses.push(this.buildDestAddress());
    setTimeout(() => {
      this.addressLists.last.focus();
    }, 4);
  }

  addDestAddressAfter() {
    this.Addresses.insert(this.focuseedAddressPosition + 1, this.buildDestAddress());
    setTimeout(() => {
      this.addressLists['_results'][this.focuseedAddressPosition + 1].focus();
    }, 4);
  }

  removeCurrentAddress() {
    this.Addresses.removeAt(this.focuseedAddressPosition);

    this.checkedAddresses = this.Addresses.value.filter(val => {
      return !(!val.address_id && !val.lat && !val.lng && !val.id);
    });

    if (!this.currentOrder) {
      if (this.checkedAddresses.length > 1 || this.orderForm.controls.incity.value) {
        this.countPrice();
      }
    } else {
      this.fareStatus.status = false;
    }
  }

  removeDestAddress(index) {
    this.Addresses.removeAt(index);
    this.checkedAddresses = this.Addresses.value.filter(val => {
      return !(!val.address_id && !val.lat && !val.lng && !val.id);
    });

    if (!this.currentOrder) {
      if (this.checkedAddresses.length > 1 || this.orderForm.controls.incity.value) {
        this.countPrice();
      }
    } else {
      this.fareStatus.status = false;
    }
  }

  timer() {
    setTimeout(() => {
      this.CurrentTime = this.pad(new Date().getHours()) + ':' + this.pad(new Date().getMinutes());
      this.timer();
    }, 10000);
  }

  clearInput() {
    this.orderForm.get('tarif').setValue({ name: '', id: '' });
    this.filteredProducts = this.products;
    // this.trigger.openPanel();
  }

  setDefaultTariff() {
    if (this.currentOrder) {
      return;
    }
    console.log(this.orderForm.get('tarif').value);

    if (this.products.find(product => product.id == this.orderForm.get('tarif').value.id)) {
      return;
    }
    console.log(this.products);

    this.orderForm.get('tarif').patchValue({
      name: this.products[0].name,
      id: this.products[0].id,
      is_default: this.products[0].is_default
    });

    this.products.map(tariff => {
      if (tariff.is_default == true) {
        this.orderForm.get('tarif').patchValue({
          name: tariff.name,
          id: tariff.id,
          is_default: tariff.is_default
        });
      }
    });

    /*if (!tariff.value.name) {
            const id = this.products[0].id;
            const name = this.products[0].name;
            tariff.setValue({ id, name });
        }*/
  }

  showWarning(event) {
    if (this.lockService.mode == 'normal') {
      let dialogRef = this.dialog.open(ModalCloseComponent, <MatDialogConfig>{
        data: { headerTemplate: 'UTAX_FRONT_ADDRESS_EDIT_WARNING' }
      });
      this.opened = true;
      dialogRef
        .afterClosed()
        .pipe(
          mergeMap(data => {
            if (data === 'true') {
              return this.lockService.lock({ id: this.currentOrder.id, mode: 'force' });
            } else {
              event.target.blur();
              return of();
            }
          })
        )
        .subscribe(res => {});
    }
  }

  setAddressPosition(index) {
    this.focuseedAddressPosition = index;
    this.triggersArr = this.triggers.toArray();
    if (!this.checkedAddresses.length) {
      this.addressType = 'all';
      this.processAddressQuery(this.query);
    }
  }

  unsetAddressPosition() {
    this.focuseedAddressPosition = null;
  }

  pad(digit: any) {
    return digit <= 9 ? '0' + digit : digit;
  }

  toFormGroup(data?): FormGroup {
    if (this.orderForm) {
      this.orderForm.reset();
    }

    if (data) {
      console.log('TCL: data', data);
      this.passService.getPassengerById(data.passenger.id, data.service_id).subscribe(res => {
        this.passengerCountOrders = res['completed_requests_count'];
        this.passengerIsBlocked = res['data']['is_blocked'];
        this.commentAboutPassenger = res['data'].comment;
        this.visitedAddresses = res['addresses'];
        this.bonus_balance = +res['bonus_balance'];
      });
      let preorderTime =
        data.assigned_at !== null
          ? this.pad(new Date(Date.parse(data.assigned_at)).getHours()) +
            '.' +
            this.pad(new Date(Date.parse(data.assigned_at)).getMinutes())
          : '';

      const formGroup = this.fb.group({
        activeFeatures: [''],
        orderType: [
          {
            value: data.is_from_app
            // disabled: true
          }
        ],
        service: [data.service_id],
        tarif: this.fb.group({
          name: [data.product.display_name, [Validators.required]],
          id: [data.product.id, [Validators.required]]
        }),
        passenger: this.fb.group({
          id: [data.passenger.id],
          phone: [data.passenger.phone_number, [Validators.pattern('[+]?38[0-9]{10}')]],
          phone_number: [data.phone_number ? data.phone_number : '', [Validators.pattern('[+]?38[0-9]{10}')]],
          name: [data.passenger.name],
          comment: [data.passenger.comment]
        }),
        intercity: [data.is_intercity],
        is_incomplete: [data.is_incomplete],
        incity: [data.is_by_the_city],
        payment_type: [data.payment_type],
        preorderedTime: [{ value: preorderTime, disabled: true }],
        preorderedDate: [
          {
            value: data.assigned_at ? new Date(data.assigned_at).toISOString() : new Date().toISOString(),
            disabled: true
          }
        ],
        addresses: this.fb.array(this.buildAddresses(data.waypoints)),
        disp_comment: [data.disp_comment],
        pass_comment: [data.pass_comment ? data.pass_comment : ''],
        bonus: [data.payment_type == 'bonus'],
        features: this.fb.array([])
      });

      this.entrance = data.start_comment;

      this.fare = Object.assign({}, data.fare);

      this.fareStatus.show = true;
      if (data.is_locked && data.locked_by != localStorage.getItem('user_id')) {
        // TODO if open locked order disable all form
        this.lock_buttons = true;
        formGroup.disable();
      } else {
        this.fareStatus.status = true;
      }
      return formGroup;
    } else {
      let tarifId = this.taxiServices[0].id.toString();
      const formGroup = this.fb.group({
        activeFeatures: [''],
        orderType: [false],
        service: [this.info ? this.info.service : this.taxiServices[0].id],
        tarif: this.fb.group({
          name: [this.info ? this.info.product.name : this.tarif[tarifId][0].name],
          id: [this.info ? this.info.product.id : this.tarif[tarifId][0].id]
        }),
        passenger: this.fb.group({
          id: [''],
          phone: [this.info ? this.info.phone : '', [Validators.pattern('[+]?38[0-9]{10}')]],
          phone_number: ['', [Validators.pattern('[+]?38[0-9]{10}')]],
          name: [''],
          comment: ['']
        }),
        intercity: [false],
        is_incomplete: [false],
        incity: [false],
        payment_type: ['cash'],
        preorderedTime: ['', Validators.maxLength(5)],
        preorderedDate: [new Date().toISOString()],
        addresses: this.fb.array([this.buildDestAddress(), this.buildDestAddress()]),
        disp_comment: [''],
        pass_comment: [''],
        bonus: [false],
        features: this.fb.array([])
      });
      return formGroup;
    }
  }

  handleServiceEvent(message) {
    this.snackBar.openFromComponent(EventMessageComponent, <MatSnackBarConfig>{
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        message
      }
    });
  }

  deletePassAddress(event, address) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(ModalCloseComponent, <MatDialogConfig>{
      data: { headerTemplate: 'DELETE_PASSANGER_ADDRESS?' }
    });
    dialogRef
      .afterClosed()
      .pipe(
        mergeMap((confirmed: string) => {
          if (confirmed === 'true') {
            return this.addressService.removePassAddress(
              this.orderForm.controls.passenger.value.id,
              address.idForDeleting
            );
          } else {
            return of(false);
          }
        })
      )
      .subscribe((deleted: boolean) => {
        if (deleted) {
          this.filtredAddress = this.filtredAddress.filter(fillAdd => fillAdd.idForDeleting !== address.idForDeleting);
        }
      });
  }

  private setEditTimer(): void {
    this.timeToLockInMilisec =
      this.settingsService.settings[this.data.order.service_id][
        'requests_operator_lock_timeout'
      ] * 1000;

    setInterval(() => {
      if (this.timeToLockInMilisec > 0) {
        this.timeToLockInMilisec = this.timeToLockInMilisec - 1000;
        if (this.timeToLockInMilisec < 60000) {
          this.timerEnding = true;
        }
      }
      this.timerString = this.millisToMinutesAndSeconds(this.timeToLockInMilisec);
    }, 1000);
  }

  private millisToMinutesAndSeconds(millis: number): string {
    const minutes = Math.floor(millis / 60000);
    const seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ':' + (+seconds < 10 ? '0' : '') + seconds;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/order-form/order-form.component.ts